/**
 * Keys used for persisting and identifying related filter dropdowns.
 * Each key corresponds to a specific filter section in the UI.
 */
const FILTERS_KEYS = {
	vessels: {
		clients: "vessels_clients-filter",
		distributors: "vessels_distributors-filter",
		businessUnits: "vessels_businessUnits-filter",
		status: "vessels_status_filter",
	},
	users: {
		roles: "users_roles_filter",
		distributors: "users_distributors_filter",
		clients: "users_clients_filter",
		businessUnits: "users_business_units_filter",
		status: "users_status_filter",
	},
	clients: {
		businessUnits: "clients_business_units_filter",
		distributors: "clients_distributors_filter",
	},
	requestsManagement: {
		devices: "request_management_devices_filter",
		vessels: "request_management_vessels_filter",
		status: "request_management_status_filter",
		date: "request_management_date_filter",
	},
	resellers: {
		businessUnits: "resellers_business_units_filter",
		distributors: "resellers_distributors_filter",
	},
	stock: {
		client: "stock_client_filter",
		distributor: "stock_distributor_filter",
		businessUnits: "stock_business_units_filter",
		status: "stocks_status_filter",
	},
};

export default FILTERS_KEYS;
